function babsadjustScreenLayout() {
  const width = window.innerWidth;

  if (width <= 768) {
    

    // Hide desktop-only content
    const desktopOnly = document.querySelectorAll('.desktop-only');
    desktopOnly.forEach(el => el.style.display = "none");

    // Show babs menu button
    const babsToggle = document.querySelector('.babs-menu-toggle');
    if (babsToggle) babsToggle.style.display = 'block';

    const babsToggle1 = document.querySelector('.babs-menu-toggle1');
    if (babsToggle1) babsToggle1.style.display = 'block';
    
        // Open ___babsFiltermob
    document.getElementById("babstsidebar").onclick = function() {
      document.getElementById("babsmysidebar").style.width = "250px";
    };
    
    // Close ___babsFiltermob
    document.getElementById("babsclosebar").onclick = function() {
      document.getElementById("babsmysidebar").style.width = "0";
    };
    

  } else {
    // Revert changes for desktop
   

    const desktopOnly = document.querySelectorAll('.desktop-only');
    desktopOnly.forEach(el => el.style.display = "");

    const babsToggle = document.querySelector('.babs-menu-toggle');
    if (babsToggle) babsToggle.style.display = 'none';

    const babsToggle1 = document.querySelector('.babs-menu-toggle1');
    if (babsToggle1) babsToggle1.style.display = 'none';

  }
}

// Call on page load and window resize
window.addEventListener('load', babsadjustScreenLayout);
window.addEventListener('resize', babsadjustScreenLayout);
